import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Campus} from '../../model/Campus';
import {GlobalService} from '../../services/global/global.service';
import {DataLoaderService} from '../../services/data-loader/data-loader.service';
import {Helper} from '../../model/Helper';

export interface DownloadAssetBundlePayload {
  campus: Campus;
  platform: string;
}

export interface EditCampusPayload {
  campus: Campus;
}

@Component({
  selector: 'app-campus-card',
  templateUrl: 'campus-card.component.html',
  styleUrls: ['campus-card.component.css'],
})

export class CampusCardComponent {
  @Input() public campus: Campus;
  @Output() public downloadAssetBundle = new EventEmitter<DownloadAssetBundlePayload>();
  @Output() public editCampus = new EventEmitter<EditCampusPayload>();

  public Helper = Helper;

  public downloadAssetBundleClicked(platformID: string): void {
    this.downloadAssetBundle.emit({
      campus: this.campus,
      platform: platformID,
    });
  }

  public editButtonClicked(): void {
    this.editCampus.emit({campus: this.campus});
  }
}
